/**
 * @module survey_elements
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyElementActions } from '~/behaviors/actions/survey_element.action';
import { surveyActions } from '~/behaviors/actions/survey.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const defaultState = {};

const reset = () => defaultState;

const mergeSurveyElements = (state, action) => {
  const surveyElements = action?.payload?.entities?.surveyElements || {};
  Object.values(surveyElements).forEach((surveyElement) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[surveyElement.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[surveyElement.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...surveyElement,
    };
  });
};

const removeSurveyElement = (state, action) => {
  const surveyElementId = action?.payload?.surveyElementId;

  if (surveyElementId) {
    const { [surveyElementId]: _deletedElement, ...remainingElements } = state;

    return remainingElements;
  }
};

const orderSurveyElements = (state, action) => {
  const surveyElements = action?.payload?.surveyElements || [];
  surveyElements.forEach((surveyElement) => {
    state[surveyElement.id] = {
      ...state[surveyElement.id],
      orderIndex: surveyElement.orderIndex,
    };
  });
};

const mergeBenchmarkedQuestionTranlations = (state, action) => {
  const { surveyElementId, surveyElementLanguages } = handleUnsafeOptionalChaining(action?.payload);
  state[surveyElementId] = {
    ...state[surveyElementId],
    benchmarkQuestionTranslations: [...surveyElementLanguages],
  };
};

const surveyElements = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(surveyElementActions.getLibraryQuestions.fulfilled, mergeSurveyElements);
  builder.addCase(surveyElementActions.getTrendQuestions.fulfilled, mergeSurveyElements);
  builder.addCase(surveyActions.fetchSurveyWithSurveyElements.fulfilled, mergeSurveyElements);

  builder.addCase(surveyElementActions.fetchSurveyElementsBySurveys.fulfilled, mergeSurveyElements);

  builder.addCase(surveyElementActions.createSurveyElement.fulfilled, mergeSurveyElements);
  builder.addCase(surveyElementActions.updateSurveyElement.fulfilled, mergeSurveyElements);
  builder.addCase(surveyElementActions.deleteSurveyElement.fulfilled, removeSurveyElement);
  builder.addCase(surveyElementActions.orderSurveyElements.fulfilled, orderSurveyElements);

  builder.addCase(surveyActions.fetchBenchmarkedQuestionTranslations.fulfilled, mergeBenchmarkedQuestionTranlations);
});

export default surveyElements;
